// Allows usage of global event emitter in a vue 3 composition like way via useEmitter()
/*
    Example in a vue setup method
    import useEmitter from '@plugins/useEmitter'

    export default {
    setup() {
        const emitter = useEmitter()
        ...
    }
    ...
    }
*/

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function useDayJs() {
    return dayjs;
}
